import { Image } from 'atoms/Image/Image';
import logoImg from './logo.svg';

export const Logo = ({ className }: { className?: string }) => {
  return <Image className={className} src={logoImg.src} alt="logo" />;
};
